module.exports = __webpack_public_path__ + "media/images/contactese/whatsapp-53c175e362828d32a4359b375420f2e5.svg";